import React, { useEffect, useState } from 'react'
import { getImages } from '../Components/const'
import { motion } from "framer-motion";
import ModalLayout from '../Components/Common/ModalLayout';
import ScheduleServiceModal from '../Components/Service/ScheduleServiceModal';
import { Link, useLocation } from 'react-router-dom';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import SeoMeta from '../Components/Common/SeoMeta';

const Service = () => {
    const location = useLocation();
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    const [scheduleServiceModal, setScheduleServiceModal] = useState(false);
    const chandleScheduleServiceModal = () => {
        setScheduleServiceModal(true)
        document.body.classList.add('body-overflow');
    }
    const closeScheduleServiceModal = () => {
        setScheduleServiceModal(false)
        document.body.classList.remove('body-overflow');
    }
    useEffect(() => {
        if (location.state?.openRequestModal) {
            setScheduleServiceModal(true);
            document.body.classList.add('body-overflow');
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);
    UseScrollReveal();

    const hideSpecials = true;
    return (
        <>
            <SeoMeta
                title="McLaren Service Orlando FL | Certified McLaren Maintenance"
                description="Schedule certified McLaren service in Orlando, FL. From routine maintenance to expert repairs, our factory-trained technicians are here to help."
                keywords=""
                ogTitle="McLaren Service Orlando FL | Certified McLaren Maintenance"
                ogDescription="Schedule certified McLaren service in Orlando, FL. From routine maintenance to expert repairs, our factory-trained technicians are here to help."
            />
            <section className='common-banner-wrap'>
                <img src={getImages('service-bg.webp')} alt='service' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Service Department</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <button type='button' onClick={chandleScheduleServiceModal} className='theme-btn text-uppercase d-inline-block'>SCHEDULE VISIT</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exprience-wrap d-flex align-items-center'>
                <div className='w-50 order-2 exprience-image'>
                    <img className='w-100' src={getImages('exprience-image.webp')} alt='exprience' />
                </div>
                <div className='w-50'>
                    <div className='mxw-530 mx-auto'>
                        <h3 className='xs-title fw-bold text-orange text-uppercase mb-2 wow reveal fadeInUp'>Experience</h3>
                        <h2 className='lg-title text-white text-uppercase mb-2 wow reveal fadeInUp'>pure Excellence</h2>
                        <h4 className='xs-title fw-300 font-1-1em mb-4 text-lgray text-uppercase wow reveal fadeInUp'>Expert Care for Your McLaren</h4>
                        <ul className='ca-info-list wow reveal fadeInUp'>
                            <li>Preventive Maintenance</li>
                            <li>Transmission Servicing</li>
                            <li>Electrical Diagnostics</li>
                            <li>Brakes and Fluids</li>
                            <li>Parts Replacement</li>
                        </ul>
                        <div className='mt-5 row gx-5 wow reveal fadeInUp'>
                            <div className='col-6'>
                                <button type='button' onClick={chandleScheduleServiceModal} className='sub-sm-btn d-block w-100'>Contact Service</button>
                            </div>
                            <div className='col-6'>
                                <Link to='/order-parts' className='sub-sm-btn d-block w-100'>Order Parts</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {!hideSpecials && 
                <section className='special-offer-wrap'>
                    <div className='container'>
                        <div className='row so-block'>
                            <div className='col-lg-6 col-12 wow reveal fadeInUp'>
                                <div className='so-box'>
                                    <div className='so-image'>
                                        <img src={getImages('special-offer-image2.webp')} alt='special offer' />
                                    </div>
                                    <div className='so-content'>
                                        <h2 className='xs-title font-1-9em mb-1 text-uppercase'>Special Offer Here</h2>
                                        <div className='so-min-h'>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                                        </div>
                                        <div className='d-flex align-items-center justify-content-between mt-2'>
                                            <div className='fv-price font-1-9em pt-1'>$899.00</div>
                                            <div>
                                                <button type="button" onClick={chandleScheduleServiceModal} className="theme-btn text-uppercase">Book Service</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-12 mt-4 mt-lg-0 wow reveal fadeInUp'>
                                <div className='so-box'>
                                    <div className='so-image'>
                                        <img src={getImages('special-offer-image1.webp')} alt='special offer' />
                                    </div>
                                    <div className='so-content'>
                                        <h2 className='xs-title font-1-9em mb-1 text-uppercase'>Special Offer Here</h2>
                                        <div className='so-min-h'>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                                        </div>
                                        <div className='d-flex align-items-center justify-content-between mt-2'>
                                            <div className='fv-price font-1-9em pt-1'>$899.00</div>
                                            <div>
                                                <button type="button" onClick={chandleScheduleServiceModal} className="theme-btn text-uppercase">Book Service</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> 
            }
            <section className='book-appointment-wrap'>
                <div className="mouse-container" onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />
                    <motion.div className='w-100 text-center mouse-text'
                        animate={{
                            x: position.x,
                            y: position.y,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    >
                        <h2 className='lg-title fw-bold text-uppercase wow reveal fadeIn'>Book your Appointment Today!</h2>
                        <h3 className='lg-title fw-300 text-uppercase mt-2 wow reveal fadeIn'>Have A Question? Call Us!</h3>
                        <button type='button' className='theme-btn mt-4 text-uppercase wow reveal fadeIn' onClick={chandleScheduleServiceModal}>Schedule Visit</button>
                    </motion.div>
                </div>
            </section>
            <section className='common-wrap expert-care-wrap'>
                <div className='container'>
                    <div className='expert-care-block'>
                        <h2 className='lg-title fw-300 text-center text-uppercase wow reveal fadeInUp'>Expert Care for your Vehicle</h2>
                        <div className=' wow reveal fadeIn'>
                            <p>Trust McLaren Orlando for our factory-trained professionals and luxury customer care and service. We invest in our staff and facility so that every moment you invest in your McLaren ownership is well spent and fully enjoyed.</p>

                            <p>We offer complete service and repair for your McLaren, for all models. Our modern service bays have all the equipment needed to diagnose and work on your vehicle and our certified technicians are always up-to-date and prepared.</p>
                        </div>
                    </div>
                </div>
            </section>
            
            <ModalLayout open={scheduleServiceModal} close={closeScheduleServiceModal} darkThemeCls='true' modalWidth={1040}>
                <ScheduleServiceModal close={closeScheduleServiceModal}/>
            </ModalLayout>
        </>
    )
}

export default Service